import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _cellErrorTypeText;

export var CellErrorTypes;

(function (CellErrorTypes) {
  CellErrorTypes["ZeroDivision"] = "__Zero Division";
  CellErrorTypes["InvalidDate"] = "__Invalid Date";
  CellErrorTypes["UnexpectedValue"] = "__Unexpected Value";
})(CellErrorTypes || (CellErrorTypes = {}));

export var cellErrorTypeText = (_cellErrorTypeText = {}, _defineProperty(_cellErrorTypeText, CellErrorTypes.ZeroDivision, 'Zero Division'), _defineProperty(_cellErrorTypeText, CellErrorTypes.InvalidDate, 'Invalid Date'), _defineProperty(_cellErrorTypeText, CellErrorTypes.UnexpectedValue, 'Unexpected Value'), _cellErrorTypeText);
export var TooltipText;

(function (TooltipText) {
  // tslint:disable-next-line:quotemark
  TooltipText["TruncatedNumber"] = "We've limited the decimal places of this value.";
  TooltipText["ZeroDivision"] = "This value is the result of dividing by zero or an empty cell.";
  TooltipText["InvalidDate"] = "The resulting date is either too far in the past or too far in the future."; // tslint:disable-next-line:max-line-length

  TooltipText["UnexpectedValue"] = "This value is the result of an unexpected value in one of your columns. For example, an error message or text in a numeric field.";
  TooltipText["ClickForMoreActions"] = "Click for more actions...";
})(TooltipText || (TooltipText = {}));